import { BiConditionOperator } from '../config/bi_report';

export const BI_CONDITION_VALUELESS_OPERATORS = [
  BiConditionOperator.IS_NULL,
  BiConditionOperator.IS_NOT_NULL,
];

const normalizeText = (value) => String(value).toLocaleLowerCase('hu-HU');

const areEqual = (value, compareValue) => {
  const numericValue = Number(value);
  const numericCompareValue = Number(compareValue);

  if (
    value !== '' &&
    compareValue !== '' &&
    Number.isFinite(numericValue) &&
    Number.isFinite(numericCompareValue)
  ) {
    return numericValue === numericCompareValue;
  }

  return normalizeText(value) === normalizeText(compareValue);
};

const compareNumbers = (value, compareValue, comparison) => {
  if (value === '' || value === null || value === undefined || compareValue === '') return false;

  const numericValue = Number(value);
  const numericCompareValue = Number(compareValue);
  return Number.isFinite(numericValue) && Number.isFinite(numericCompareValue)
    ? comparison(numericValue, numericCompareValue)
    : false;
};

export const evaluateBiCondition = (value, condition) => {
  const compareValue = condition?.compareValue;

  switch (condition?.operator) {
    case BiConditionOperator.EQ:
      return value !== null && value !== undefined && areEqual(value, compareValue);
    case BiConditionOperator.NE:
      return value !== null && value !== undefined && !areEqual(value, compareValue);
    case BiConditionOperator.LT:
      return compareNumbers(value, compareValue, (left, right) => left < right);
    case BiConditionOperator.LTE:
      return compareNumbers(value, compareValue, (left, right) => left <= right);
    case BiConditionOperator.GT:
      return compareNumbers(value, compareValue, (left, right) => left > right);
    case BiConditionOperator.GTE:
      return compareNumbers(value, compareValue, (left, right) => left >= right);
    case BiConditionOperator.CONTAINS:
      return value !== null && value !== undefined && normalizeText(value).includes(normalizeText(compareValue));
    case BiConditionOperator.NOT_CONTAINS:
      return value !== null && value !== undefined && !normalizeText(value).includes(normalizeText(compareValue));
    case BiConditionOperator.STARTS_WITH:
      return value !== null && value !== undefined && normalizeText(value).startsWith(normalizeText(compareValue));
    case BiConditionOperator.ENDS_WITH:
      return value !== null && value !== undefined && normalizeText(value).endsWith(normalizeText(compareValue));
    case BiConditionOperator.IS_NULL:
      return value === null || value === undefined || value === '';
    case BiConditionOperator.IS_NOT_NULL:
      return value !== null && value !== undefined && value !== '';
    default:
      return false;
  }
};

export const findMatchingBiRule = (value, rules = []) => {
  const orderedRules = [...rules].sort(
    (left, right) => (left.sortOrder ?? 0) - (right.sortOrder ?? 0)
  );
  const matchingRule = orderedRules.find(
    (condition) => !condition.isDefault && evaluateBiCondition(value, condition)
  );

  return matchingRule ?? orderedRules.find((condition) => condition.isDefault) ?? null;
};

export const evaluateBiConditions = (value, conditions = []) => {
  return findMatchingBiRule(value, conditions)?.resultValue ?? '';
};

export const evaluateBiFieldColor = (value, colors = []) => {
  return findMatchingBiRule(value, colors)?.resultColor ?? null;
};
